import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  FormGroup,
  Popover,
  PopoverBody,
  FormText
} from 'reactstrap';

import debounceFunction from 'lodash/debounce';

import InformationSVG from '../../assets/information.svg';

import { generateGUID  } from '../../utils';


const REMAINING_CHARACTERS_THRESHOLD = 15;

class TextInput extends Component {
  constructor(){
    super();

    this.state = {
      currentLength:0,
      isPeeking:false,
      value:'',
      randomId:generateGUID(),
      tooltipOpen:false
    };
  }

  componentWillMount(){
    const {
      onChange,
      debounce,
      defaultValue,
      value
    } = this.props;

    this.handleChangeDebounced = debounceFunction(onChange.bind(this),debounce);
    
    if(defaultValue){
      this.setState({value:defaultValue});
    } else if(value){
      this.setState({value:value});
    }
  }

  handleChange(event){
    event.persist();
    if(event.target.value.length <= this.props.maxLength){
      this.setState({
        value:event.target.value,
        currentLength:event.target.value.length
      });
      this.handleChangeDebounced(event.target.value);
    }
  }

  handleCopyPasteClick(event){
    console.log('INPUT ',this.input);

    this.input.select();
    document.execCommand('copy');
  }

  getType(){
    const {number, hidden, multiline} = this.props;
    const { isPeeking } = this.state;

    if(number) return 'number';
    if(hidden && !isPeeking) return 'password';
    if(hidden && isPeeking) return 'text';
    if(multiline) return 'textarea';
    return 'text'
  }

  render(){
    const {
      id,
      warning,
      name,
      onFocus,
      onBlur,
      maxLength,
      hidden,
      placeholder,
      readOnly,
      label,
      ignoreLengthFeedback,
      autoComplete,
      copyPaste,
      info,
      showLengthIndicatorAtLength,
      disabled,
      tooltip
    } = this.props;

    const {
      currentLength,
      isPeeking,
      value,
      randomId,
      tooltipOpen
    } = this.state;

    const remainingCharacters = maxLength - currentLength,
      isInvalid = (warning.length > 0 || (remainingCharacters <= 0 && !ignoreLengthFeedback))

    return (
      <FormGroup>
        {label.length > 0 && (
          <span>
            <Label>{label}</Label>
            {tooltip && (
              <span>
                &nbsp;&nbsp;
                <img
                  alt='Tooltip information'
                  src={InformationSVG}
                  id={`tooltip_${randomId}`}
                  onMouseEnter={() => this.setState({tooltipOpen:true})}
                  onMouseLeave={() => this.setState({tooltipOpen:false})}
                />
                <Popover
                  className='TooltipPopover'
                  isOpen={tooltipOpen}
                  target={`tooltip_${randomId}`}
                  placement='right'
                >
                  <PopoverBody>{tooltip}</PopoverBody>
                </Popover>
              </span>              
            )}
          </span>
        )}
        <InputGroup>
          <Input
            autoComplete={autoComplete}
            id={id}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            type={this.getType()}
            name={name}
            invalid={isInvalid}
            onChange={(e) => this.handleChange(e)}
            onFocus={(e) => onFocus(e)}
            onBlur={(e) => onBlur(e)}
            maxLength={maxLength}
            style={{borderRight:(hidden || copyPaste) ? '0px' : ''}}
            readOnly={readOnly}
            innerRef={(i) => this.input = i}
          />
          {hidden && (
            <InputGroupAddon
              className='TransparentAddon'
              onClick={() => this.setState({isPeeking:!isPeeking})}
              addonType="append"
            >
              <InputGroupText className='TransparentAddonText'>
                <i className={`fa fa-eye${isPeeking ? '-slash' : ''}`} aria-hidden='true' />
              </InputGroupText>
            </InputGroupAddon>
          )}
          {!hidden && copyPaste && (
            <InputGroupAddon
              style={{
                cursor:'pointer',
                backgroundColor:readOnly ? '#eceeef' : 'transparent',
                borderColor: '#d9d9d9'
              }}
              onClick={(e) => this.handleCopyPasteClick(e)}
              addonType="append"
            >
              <InputGroupText>
                <i className='fa fa-copy' aria-hidden='true' />
              </InputGroupText>
            </InputGroupAddon>
          )}
        </InputGroup>
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
        {warning.length === 0 && remainingCharacters <= 0 && !ignoreLengthFeedback && (
          <FormText className='FadedFeedback'>Only {maxLength} characters allowed</FormText>
        )}
        {warning.length === 0 && remainingCharacters < showLengthIndicatorAtLength + 1 && remainingCharacters > 0 && !ignoreLengthFeedback && (
          <FormText className='FadedFeedback'>{remainingCharacters} characters remaining</FormText>
        )}
      </FormGroup>
    )
  }
}

TextInput.propTypes = {
  id:PropTypes.string,
  hidden:PropTypes.bool,
  copyPaste:PropTypes.bool,
  number:PropTypes.bool,
  multiline:PropTypes.bool,
  placeholder:PropTypes.string,
  name:PropTypes.string,
  debounce:PropTypes.number.isRequired,
  onChange:PropTypes.func.isRequired,
  onFocus:PropTypes.func,
  onBlur:PropTypes.func,
  maxLength:PropTypes.number,
  warning:PropTypes.string.isRequired,
  readOnly:PropTypes.bool,
  defaultValue:PropTypes.string,
  value:PropTypes.string,
  label:PropTypes.string,
  autoComplete:PropTypes.string,
  ignoreLengthFeedback:PropTypes.bool,
  info:PropTypes.string,
  tooltip:PropTypes.oneOfType([PropTypes.string,PropTypes.object])
};

TextInput.defaultProps = {
  disabled:false,
  number:false,
  placeholder:'',
  multiline:false,
  readOnly:false,
  isPassword:false,
  copyPaste:false,
  debounce:0,
  onChange:() => {},
  onBlur:() => {},
  onFocus:() => {},
  warning:'',
  label:'',
  showLengthIndicatorAtLength:REMAINING_CHARACTERS_THRESHOLD,
  maxLength:Number.POSITIVE_INFINITY,
  autoComplete:'off',
  ignoreLengthFeedback:false,
  info:''
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/shared/components/TextInput/TextInput.js